export default __webpack_public_path__ + "static/media/ocaml.53c71fd5.png";